<template>
  <el-dialog
    class="group-dialog"
    title
    :visible.sync="dialogVisible"
    width="6rem"
    style="overflow:hidden"
  >
    <div class="dialog-content">
      <div class="dialog-middle">
        <div class="dialog-tabs">
          <span
            class="dialog-tab active"
            v-if="groupSelectedType === 1"
            v-on:click="SelectGroup(1)"
          >{{$t('global.添加到频道')}}</span>
          <span class="dialog-tab active" v-if="groupSelectedType === 2">{{$t('global.添加到频道')}}</span>
        </div>
        <div class="jline"></div>
        <div class="dialog-search">
          <div
            class="search-list"
            v-show="groupSelectedType==1"
            :class="{'long':count(myCreatedSubjectList)>6}"
          >
            <el-form ref="createForm" :model="createForm" v-if=" count(myCreatedSubjectList) > 0">
              <el-form-item>
                <el-radio-group v-model="createForm.createId">
                  <div v-for="(item,key,index) in myCreatedSubjectList" :key="index">
                    <el-radio
                      v-for="(items, indexs) of item"
                      :key="indexs"
                      :label="items.id"
                      name="createId"
                    >{{items.title}}</el-radio>
                  </div>
                </el-radio-group>
              </el-form-item>
            </el-form>
            <div v-else class="noSubject">{{$t('global.还未创建频道')}}</div>
          </div>
          <div
            class="search-list"
            v-show="groupSelectedType==2"
            :class="{'long':count(myJoinedSubjectList)>6}"
          >
            <el-form ref="joinForm" :model="joinForm" v-if="count(myJoinedSubjectList) > 0">
              <el-form-item>
                <el-checkbox-group v-model="joinForm.joinId">
                  <div v-for="(item,key,index) in myJoinedSubjectList" :key="index">
                    <el-checkbox
                      v-for="(items, indexs) of item"
                      :key="indexs"
                      :label="items.id"
                      name="joinId"
                    >{{items.title}}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
            <div v-else class="noSubject">{{$t('global.还未关注频道')}}</div>
          </div>

          <div
            class="search-list"
            v-show="groupSelectedType==3"
            :class="{'long':count(mycreateAndJoinSbuhectList)>6}"
          >
            <el-form ref="joinForm" :model="joinForm" v-if="count(mycreateAndJoinSbuhectList) > 0">
              <el-form-item>
                <el-checkbox-group v-model="joinForm.joinId">
                  <div v-for="(item,key,index) in mycreateAndJoinSbuhectList" :key="index">
                    <el-checkbox
                      v-for="(items, indexs) of item"
                      :key="indexs"
                      :label="items.id"
                      name="joinId"
                    >{{items.title}}</el-checkbox>
                  </div>
                </el-checkbox-group>
              </el-form-item>
            </el-form>
            <div v-else class="noSubject">{{$t('global.还未关注频道')}}</div>
          </div>
        </div>
      </div>
    </div>
    <el-button type="primary" @click="addToSubject" class="dialog-btn-yes">{{$t('global.确认添加')}}</el-button>
  </el-dialog>
</template>

<script>
export default {
  name: "JoinDialog",
  props: ["videoItem", "visible", "groupSelectedType"],
  data() {
    return {
      dialogVisible: false,
      groupSearchKey: "",
      myCreatedSubjectList: [],
      myJoinedSubjectList: [],
      myCreatedSubjectSelectedId: [],
      myJoinedSubjectSelectedId: [],
      mycreateAndJoinSbuhectList: [],
      myCreatedAndJoinSubjectSelectedId: [],

      joinForm: {
        joinId: []
      },
      createForm: {
        createId: ""
      }
    };
  },
  created() {},
  methods: {
    init() {
      if (localStorage.getItem("auth_token")) {
        this.getMyTopicList(1);
        this.getMyTopicList(2);

        if (this.groupSelectedType == 3) {
          this.mycreateAndJoinSbuhectList = [];
          this.mycreateAndJoinSbuhectList.addAll(this.myCreatedSubjectList);
          this.mycreateAndJoinSbuhectList.addAll(this.myJoinedSubjectList);
        }
      }
    },
    getMyTopicList(groupType) {
      var $this = this;
      this.$http
        .get("/api/u/topic/myTopicList?type=" + groupType)
        .then(function(response) {
          if (response) {
            if (groupType == 1) {
              $this.myCreatedSubjectList = response.data.topicResponseMap;
            } else if (groupType == 2) {
              $this.myJoinedSubjectList = response.data.topicResponseMap;
            }
          }
        });
    },
    count(o) {
      var t = typeof o;
      if (t == "string") {
        return o.length;
      } else if (t == "object") {
        var n = 0;
        for (var i in o) {
          n++;
        }
        return n;
      }
      return false;
    },
    searchMyTopic() {
      this.getMyTopicList(this.groupSelectedType);
    },
    addToSubject() {
      var $this = this;
      if (this.groupSelectedType == 1) {
        this.myCreatedSubjectSelectedId = this.createForm.createId;
        if (this.myCreatedSubjectSelectedId == false) {
          $this.$message({
            message: this.$t("global.请选择频道"),
            type: "error",
            duration: 2000
          });
          return;
        }
        this.$http
          .post("/api/u/topic/addBatch", {
            videoId: this.videoItem.videoId,
            topicIds: this.myCreatedSubjectSelectedId
          })
          .then(function(response) {
            $this.$message({
              message: $this.$t("global.添加成功"),
              type: "success",
              duration: 2000
            });
            $this.$emit("hiddendialog");
          });
      } else {
        this.myJoinedSubjectSelectedId = this.joinForm.joinId;
        if (this.myJoinedSubjectSelectedId == false) {
          $this.$message({
            message: this.$t("global.请选择频道"),
            type: "error",
            duration: 2000
          });
          return;
        }
        this.$http
          .post("/api/u/topic/recommendBatch", {
            videoId: this.videoItem.videoId,
            topicIds: this.myJoinedSubjectSelectedId.join()
          })
          .then(function(response) {
            $this.$message({
              message: $this.$t("global.操作成功，请等待审核"),
              type: "success",
              duration: 2000
            });
            $this.$emit("hiddendialog");
          });
      }
    },
    SelectGroup(groupType) {
      this.$emit("update:groupSelectedType", groupType);
    }
  },
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    },
    dialogVisible(val) {
      this.$emit("update:visible", this.dialogVisible);
      if (val) {
        this.init();
      }
    }
  }
};
</script>

<style scoped>
@import "./style/joinDialog.css";
.el-radio {
  display: block;
  margin-left: 0;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/JoinDialog.vue